import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';

import { DS_BUTTON_SOCIAL_VARIANT_ARRAY, DsButtonSocial, DsButtonSocialAppArray, DsButtonSocialVariant } from '@frontend/ui/button-social';
import { FormElementTemplateForClient, LoginProvider, LoginProviderProfile, UtilsService } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { LoginProvidersService } from '@frontend/vanilla/shared/login-providers';
import { Observable, map } from 'rxjs';

import { LoginContentService } from './login-content.service';

@Component({
    imports: [CommonModule, DsButtonSocial, IconCustomComponent],
    selector: 'vn-login-provider-button',
    templateUrl: 'login-provider-button.html',
})
export class LoginProviderButtonComponent implements OnInit {
    private loginProvidersService = inject(LoginProvidersService);
    private loginContentService = inject(LoginContentService);
    private utilsService = inject(UtilsService);

    @Input({ transform: (value: string) => value as LoginProvider }) provider: LoginProvider;
    @Output() loginEvent = new EventEmitter<boolean>();
    dsProvider: DsButtonSocialAppArray;
    readonly Provider = LoginProvider;
    profile$: Observable<LoginProviderProfile>;
    buttonForm: FormElementTemplateForClient | undefined;
    buttonVariant: DsButtonSocialVariant = 'filled';
    buttonIcon: string | undefined;
    disabled: boolean;

    ngOnInit() {
        this.profile$ = this.loginProvidersService.providersProfile.pipe(
            map(
                (profiles: LoginProviderProfile[] | null) =>
                    profiles?.find((profile: LoginProviderProfile) => profile.provider === this.provider) || { provider: this.provider },
            ),
        );
        this.buttonForm = this.loginContentService.content.form[this.provider + 'button'];
        this.buttonVariant = DS_BUTTON_SOCIAL_VARIANT_ARRAY.find((variant) => variant === this.buttonForm?.htmlAttributes?.variant) ?? 'filled';
        this.buttonIcon = this.buttonForm?.htmlAttributes?.iconName;
        this.dsProvider = <DsButtonSocialAppArray>this.provider;
    }

    emmitLogin(isConnected: boolean) {
        this.disabled = true;
        this.loginEvent.emit(isConnected);
    }

    getLabel(profileName?: string): string {
        return profileName
            ? this.utilsService.format(this.loginContentService.content.messages?.ContinueAs || '', profileName)
            : this.buttonForm?.label || '';
    }

    getBackgroundImage(isConnected: boolean) {
        const contentName = this.provider + (isConnected ? 'icon' : 'image');
        const content: any = this.loginContentService.content.children[contentName];
        const src: string = content?.image?.src;

        return src ? { 'background-image': `url(${src})` } : null;
    }
}
